<template>
    <DModal
        v-model="activity_log_comment"
        :show="showModal"
        :title="__('customers.contracts.release_tree_confirm_title')"
        :message="message"
        is-confirm
        :is-awaiting-validation="true"
        :show-change-reason-input="true"
        @update:show="$emit('update:showModal', $event)"
        @confirm="releaseContractTreeConfirm"
        @close="$emit('close-modal')"
    />
</template>

<script>
export default {
    name: 'ReleaseTreeContractModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        redirectTo: {
            type: String,
            default: 'contract-list'
        },
        message: {
            type: String,
            default: ''
        },
        filters: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            activity_log_comment: ''
        }
    },
    methods: {
        releaseContractTreeConfirm () {
            this.$inertia.post(this.$route('customers.customers.contracts.release-tree-contract', {
                customer: this.contract.customer_id,
                contract: this.contract.id,
                redirectTo: this.redirectTo,
                activity_log_comment: this.activity_log_comment,
                filters: this.filters
            }),
            {},
            {
                onSuccess: () => {
                    this.$emit('close-modal')
                }
            })
        }
    }
}
</script>
